/******************************************************************************
 *
 * WorkDetailsPage
 *
 * Container Page
 *
 * Responsibilities
 *
 * ✓ Read Route Parameter
 * ✓ Load Work Details
 * ✓ Arrange Components
 *
 ******************************************************************************/

import React, { useState } from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import useWorkDetails
from "../hooks/useWorkDetails";

import {
    groupAssignments
}
from "../utils/workHelpers";

//import WorkActionBar from "../components/WorkActionBar";

//import WorkDashboardHeader from "../components/WorkDashboardHeader";

import PageHeader from "../components/PageHeader";
//import SummaryCard from "../components/SummaryCard";

import WorkPeopleCard
from "../components/WorkPeopleCard";

import WorkChecklistCard
from "../components/WorkChecklistCard";

import WorkItemsCard
from "../components/WorkItemsCard";

import WorkTimelineCard
from "../components/WorkTimelineCard";

import WorkDocumentsCard
from "../components/WorkDocumentsCard";

import WorkCommentsCard
from "../components/WorkCommentsCard";

import ExecutionDrawer
from "../components/ExecutionDrawer";

export default function WorkDetailsPage() {

    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);

    const { id } = useParams();

    const {

        loading,

        refresh,

        work,

        assignments,

        watchers,

        checklists,

        workItems,
        selectedWorkItem,
        setSelectedWorkItem,

        timeline,

        documents,

        comments

    } = useWorkDetails(id);

    const {

        executors,

        owners,

        approvers

    } = groupAssignments(assignments);

    if (loading) {

        return (

            <div className="container-fluid py-5 text-center">

                <div
                    className="spinner-border text-primary"
                />

                <div className="mt-3">

                    Loading Work...

                </div>

            </div>

        );

    }

    return (

        <div className="container-fluid py-4">

            {/* Action Bar */}

            
            {/* Dashboard */}

            <PageHeader

            title="Work Execution"

            subtitle="Execute, monitor and complete work"

            actions={

                <>

                    <button
                        className="btn btn-light"
                        onClick={refresh}
                    >
                        Refresh
                    </button>

                    <button
                        className="btn btn-outline-light"
                        onClick={() =>
                            navigate(`/wms/works/${id}/edit`)
                        }
                    >
                        Edit
                    </button>

                    <button
                        className="btn btn-success"
                        disabled
                    >
                        Start Work
                    </button>

                </>

    }

/>


            {/* People + Checklist */}

            {/* People */}

                <div className="mb-4">

                    <WorkPeopleCard

                        executors={executors}

                        owners={owners}

                        approvers={approvers}

                        watchers={watchers}

                    />

                </div>
            {/* Work Execution Workspace */}

            <div className="row mb-4">

                <div className="col-lg-4">

                    <WorkItemsCard

                        workItems={workItems}

                        selectedWorkItem={selectedWorkItem}

                        onSelectWorkItem={setSelectedWorkItem}
                        onExecute={(item) => {

                            setSelectedWorkItem(item);

                            setDrawerOpen(true);

                        }}

                        onRefresh={refresh}

                    />

                </div>

                <div className="col-lg-8">

                    <WorkChecklistCard

                        workItem={selectedWorkItem}

                        checklists={checklists}

                    />

                </div>

            </div>


            {/* Work Items */}

            

            {/* Timeline + Documents */}

            <div className="row mb-4">

                <div className="col-lg-6">

                    <WorkTimelineCard

                        timeline={timeline}

                    />

                </div>

                <div className="col-lg-6">

                    <WorkDocumentsCard

                        documents={documents}

                    />

                </div>

            </div>

                <ExecutionDrawer

                open={drawerOpen}

                onClose={() => setDrawerOpen(false)}

                work={work}

                workItem={selectedWorkItem}
                checklists={checklists}

            />

            {/* Comments */}

            <WorkCommentsCard

                comments={comments}

            />

        </div>

    );

}